import { render } from "./SingleSaleForNineCatalogy.vue?vue&type=template&id=5bea8a4e&scoped=true"
import script from "./SingleSaleForNineCatalogy.vue?vue&type=script&lang=js"
export * from "./SingleSaleForNineCatalogy.vue?vue&type=script&lang=js"

import "./SingleSaleForNineCatalogy.vue?vue&type=style&index=0&id=5bea8a4e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bea8a4e"]])

export default __exports__